export const isDef = (val) => val !== undefined && val !== null;
// eslint-disable-next-line @typescript-eslint/ban-types
export const isFunction = (val) => typeof val === 'function';
export const isObject = (val) => val !== null && typeof val === 'object';
export const isPromise = (val) => isObject(val) && isFunction(val.then) && isFunction(val.catch);
export const isDate = (val) => Object.prototype.toString.call(val) === '[object Date]' &&
    !Number.isNaN(val.getTime());
